// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"TermsAndConditionsAllianz_modal-content_23wVq"};